/* eslint-disable max-lines */
import React, { Component } from 'react';
import { withStyles } from 'tss-react/mui';
import {
  RecordVoiceOver,
  Psychology
} from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import PropTypes from 'prop-types';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { connect } from 'react-redux';
import {
  Tab,
  Tabs,
  Tooltip,
  IconButton,
} from '@mui/material';

import notifSystem from '../../../../../front/src/notifSystem';
import AudioDiscussion from '../AudioDiscussion';
import { formatTextToHTML } from '../../Stats/Cti/CallTable/functions';
import { getCapitalLetters } from '../../../utils/function';
import {
  AudioSpeedManager,
  PlayPauseButton,
  DurationField,
  ProgressSlider,
  CopyLink,
  VolumeManager,
  AnalyseIADisplay
} from './Components';
import styles from './styles';
import { trackAudioLinkCopy } from '../../../services/datadog';

const mapStateToProps = ({ connectedUser }) => ({ user: connectedUser });

const removeListenerCallback = f => f;

class AudioPlayer extends Component {
  state = {
    play: false,
    audio: this.props.url,
    showTranscription: 'showTranscription' in this.props ?
      this.props.showTranscription :
      !!this.props.transcription,
    hide: this.props.hide || false,
    isPlayable: false,
    playDidLoad: false,
    tab: 0,
    duration: 0,
    playbackSpeed: 1,
    playbackSpeedAnchor: null,
  };

  retrieveAudio = () => {
    const {
      hide, forceHide,
      processingTextChatgpt, transcription,
      url,
      showTranscription
    } = this.props;
    if (url) {
      this.audio = new Audio(url);
    }
    this.setState({
      audio: url,
      showTranscription: 'showTranscription' in this.props ?
        showTranscription :
        !!transcription,
      tab: transcription &&
        !hide &&
        !forceHide &&
        processingTextChatgpt ? 1 : 0
    });
    if (this.audio) {
      this.audio.preload = 'metadata';
      this.audio.playbackRate = this.state.playbackSpeed;
      this.audio.addEventListener('canplay',
        () => this.setState({ isPlayable: true }));
      this.autoPlay();
      this.audio.addEventListener('ended',
        () => this.setState({ play: false }));
      this.audio.addEventListener('loadedmetadata', () =>
        this.setState({
          volume: this.audio.volume,
          duration: this.audio.duration
        }));
      this.audio.addEventListener('durationchange', () => {
        if (this.audio.duration !== Infinity) {
          this.setState({
            duration: this.audio.duration
          });
        }
      });
      this.audio.addEventListener('timeupdate', () => this.setState({
        currentTime: this.audio.currentTime
      }));
    }
  }

  componentDidMount() {
    this.retrieveAudio();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.audio?.pause();
      this.setState({ play: false, isPlayable: false, currentTime: 0 });
      this.retrieveAudio();
    }
    if (prevProps.transcription !== this.props.transcription) {
      this.setState({ showTranscription: !!this.props.transcription });
    }
  }

  copieLink = (e, link) => {
    const { user, callerIdNumber, callDate, service } = this.props;

    // Track the link copy action
    if (user) {
      trackAudioLinkCopy({
        userId: user._id,
        userName: user.login,
        phoneNumber: callerIdNumber,
        audioUrl: link,
        callDate,
        duration: this.props.duration,
        service
      });
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(link);
      notifSystem.success('Message', 'Le lien a bien été copié');
    }
    e.stopPropagation();
  };

  componentWillUnmount() {
    if (this.audio) {
      if (this.state.playDidLoad) {
        this.audio.pause();
      }
      // remove the Listeners
      this.audio.removeEventListener('canplay', removeListenerCallback);
      this.audio.removeEventListener('ended', removeListenerCallback);
      this.audio.removeEventListener('loadedmetadata', removeListenerCallback);
      this.audio.removeEventListener('durationchange', removeListenerCallback);
      this.audio.removeEventListener('timeupdate', removeListenerCallback);
    }
  }

  formatDuration = (duration) =>
    duration && dayjs.utc(duration * 1000).isValid()
      ? dayjs.utc(duration * 1000).format('m:ss')
      : '0:00'


  play = () => {
    this.audio.play().then(() => {
      this.setState({
        playDidLoad: true,
      });
    }).catch(() => {
      this.setState({
        play: false, isPlayable: false, currentTime: 0, duration: 0
      })
    });
  }

  autoPlay = () => {
    if (this.props.autoPlay) {
      this.setState({ play: true }, () => {
        this.play();
        if (this.props.cb) {
          this.props.cb();
        }
      });
    }
  }

  togglePlay = (event) => {
    const { dontPlay } = this.props;
    if (!dontPlay) {
      event.stopPropagation();
      if (!this.audio) {
        this.retrieveAudio();
      }
      this.setState({ play: !this.state.play }, () => {
        if (this.state.play) {
          if (this.props.cb) {
            this.props.cb();
          }
          this.play();
        } else {
          this.audio.pause();
        }
      });
    } else if (this.props.cb) {
      this.props.cb();
    }
  };

  mute = (event) => {
    event.stopPropagation();
    const { volume } = this.state;
    return volume
      ? this.setState({ volume: 0 }, () => {
        this.audio.volume = 0;
      })
      : this.setState({ volume: 1 }, () => {
        this.audio.volume = 1;
      });
  }

  handleChangeVolume = (event, newValue) => {
    this.setState({ volume: newValue / 100 }, () => {
      if (this.audio) {
        this.audio.volume = newValue / 100;
      } else {
        throw new Error('Audio is undefined')
      }
    });
  };

  handleChangeTime = (event, newValue) => {
    this.setState({
      currentTime: ((newValue * this.state.duration) / 100)
    }, () => {
      if (this.audio) {
        this.audio.currentTime = ((newValue * this.state.duration) / 100);
      } else {
        throw new Error('Audio is undefined')
      }
    });
  };

  show = () => this.setState({
    showTranscription: !this.state.showTranscription
  })

  handleChangeTab = (event, tab) => this.setState({ tab });

  handleChangePlaybackSpeed = (speed) => {
    this.setState({ playbackSpeed: speed, playbackSpeedAnchor: null }, () => {
      if (this.audio) {
        this.audio.playbackRate = speed;
      } else {
        throw new Error('Audio is undefined');
      }
    });
  };

  handleOpenPlaybackSpeed = (event) => {
    this.setState({ playbackSpeedAnchor: event.currentTarget });
  };

  handleClosePlaybackSpeed = () => {
    this.setState({ playbackSpeedAnchor: null });
  };

  handleTranscriptClick = (startTime) => {
    if (!this.audio && this.props.url) {
      this.retrieveAudio();
    }
    if (startTime !== null && !isNaN(startTime)) {
      this.audio.currentTime = startTime;
      this.setState({ currentTime: startTime });

      if (!this.state.play) {
        this.setState({ play: true }, () => {
          this.play();
        });
      }
    }
  };

  render() {
    const {
      postControleAPI,
      classes,
      transcription,
      noPadding,
      noCopyIcon,
      forceHide,
      processingTextChatgpt,
      transcriptorEngine,
      processingTextEngine,
      user,
      isAnalyzing,
      analyseIA
    } = this.props;
    const {
      volume,
      currentTime,
      duration,
      showTranscription,
      mouseOn,
      hide,
      audio,
      isPlayable,
      tab,
      play,
      playbackSpeed,
      playbackSpeedAnchor
    } = this.state;

    let sliderGridXs = 4;
    if (transcription) {
      sliderGridXs = sliderGridXs - 1;
    }
    return (<Grid container className={noPadding ? '' : classes.back}>
      <PlayPauseButton
        classes={classes}
        play={play}
        duration={duration}
        togglePlay={this.togglePlay}
        audio={audio}
      />

      <DurationField
        classes={classes}
        currentTime={currentTime}
        duration={duration}
        formatDuration={this.formatDuration}
      />
      <ProgressSlider
        onClick={(event) => event.stopPropagation()}
        progressSliderXs={sliderGridXs}
        mouseOn={mouseOn}
        classes={classes}
        audio={audio}
        isPlayable={isPlayable}
        currentTime={currentTime}
        duration={duration}
        handleChangeTime={this.handleChangeTime}
      />
      {isPlayable &&
        <VolumeManager
          mouseOn={mouseOn}
          classes={classes}
          audio={audio}
          isPlayable={isPlayable}
          volume={volume}
          duration={duration}
          setState={(newState) => this.setState(newState)}
          handleChangeVolume={this.handleChangeVolume}
          mute={this.mute}
        />}

      {transcription && <Grid item className={classes.iconCenter} xs={1}>
        <IconButton onClick={this.show} size="small">
          <RecordVoiceOver className={classes.iconSmall} />
        </IconButton>
      </Grid>}

      {!noCopyIcon ? <CopyLink
        classes={classes}
        copieLink={this.copieLink}
        props={this.props}
      /> : ''}

      {permit(user) && postControleAPI && (
        <Tooltip
          className={classes.iconCenter}
          title={`${isAnalyzing ?
            'Analyse en cours' :
            'Analyser avec l\'IA pour vérifier les réponses'}`}
          placement="top"
        >
          <span>
            <IconButton
              onClick={postControleAPI}
              size="small"
              disabled={isAnalyzing}
            >
              <Psychology
                className={classes.iconSmall}
                sx={{
                  color: `${isAnalyzing ? 'gray' : 'black'} !important`
                }}
              />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {isPlayable &&
        <AudioSpeedManager
          classes={classes}
          playbackSpeed={playbackSpeed}
          playbackSpeedAnchor={playbackSpeedAnchor}
          handleOpenPlaybackSpeed={this.handleOpenPlaybackSpeed}
          handleClosePlaybackSpeed={this.handleClosePlaybackSpeed}
          handleChangePlaybackSpeed={this.handleChangePlaybackSpeed}
        />}

      {
        showTranscription && !hide && !forceHide &&
          <Grid item xs={12}>
            {
              transcription && showTranscription && !hide && !forceHide && [
                <Tabs
                  value={tab}
                  onChange={this.handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  key={1}
                  variant="fullWidth"
                >
                  <Tab
                    title={transcriptorEngine || ''}
                    label={`Transcription (${transcriptorEngine ?
                      getCapitalLetters(transcriptorEngine) : 'DG'})`}
                  />
                  <Tab
                    title={processingTextEngine || ''}
                    label={`Analyse (${processingTextEngine ?
                      processingTextEngine : 'CHATGPT'})`}
                    disabled={!processingTextChatgpt}
                  />
                </Tabs>
              ]
            }
          </Grid>
      }

      {transcription && showTranscription && !hide && !forceHide &&
        [
          tab === 0 && <Grid item xs={12}>
            {analyseIA && <AnalyseIADisplay analyseIA={analyseIA} />}
            <AudioDiscussion
              transcription={transcription}
              onTextClick={this.handleTranscriptClick}
              blurry={!permit(user, { key: 'accesCallToAndBackText' })
                && classes.blurry} />
          </Grid>,
          tab === 1 &&
          <Grid item xs={12}>{formatTextToHTML(processingTextChatgpt)}</Grid>,
        ]}
    </Grid>
    );
  }
}

AudioPlayer.PropTypes = {
  url: PropTypes.string.isRequired,
  transcription: PropTypes.string,
  callerIdNumber: PropTypes.string,
  callDate: PropTypes.string,
  service: PropTypes.string
};

export default connect(mapStateToProps)(withStyles(AudioPlayer, styles));
